<template>
  <div v-if="visible">
    <v-menu
      top
      close-delay="1"
      content-class="elevation-6 opacity-none main-note-content border-radius-1"
      allow-overflow
      color="#e4f3f7"
      transition="slide-y-transition"
      :open-on-hover="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            data-cy="notePill-items"
          class="position-absolute rounded-circle pa-0 opacity-5"
          fab
          small
          dark
          color="#7764CA"
          v-bind="attrs"
          v-on="on"
          :loading="btnLoaded"
        >
          <!-- <v-icon>mdi-file</v-icon> -->
          <v-img contain :src="iconNotes" aspect-ratio="1.1"></v-img>
        </v-btn
        >
      </template>
      <v-row v-if="visible" class="note-info position-relative d-flex justify-start align-start flex-column px-10 py-6 opacity-none">
        <v-row class="d-flex flex-row justify-start align-center ma-0">
            <img :src="indexImg" class="img-index mr-2" alt="" />
            <div class="align-middle text-left line-height-100">
                <p class="font-size-16 font-weight-bolder ma-0 text--primary">
                    {{ $t('bookReading.my_notes') }}
                </p>
                <small class="font-size-12">My notes</small>
            </div>

            <v-btn 
              icon
              dark
              color="primary"
              class="btn-closed"
              @click="setNotesDialogToFalse()"
            >
              <v-icon class="font-size-32 rounded-circle"> mdi-close-circle</v-icon>
            </v-btn>
        </v-row>
        <v-row>
          <v-col class="d-flex flex-column py-0">
            <v-checkbox
                data-cy="stickyNotes-show-all-notes-button"
                v-model="bookReadConf.showNotes"
                :label="$t('bookReading.showAllNotes')"
            />
          </v-col>
        </v-row>
        <v-row class="d-flex flex-row flex-wrap text-left note-content pa-3 mb-4 ma-0 w-100">
          <div class="col-11 pa-0">
              <div class="col-12 pa-0">
                  <v-chip
                      label
                      small
                      dark
                      color="#B8C0CC"
                      class="mb-1 font-weight-bold"
                      >
                      <span class="text-uppercase">{{ $t('bookReading.chapter') + ' ' + data.bookChapter.chapterNumber}}</span>
                      -
                      <span class="text-uppercase">{{ $t('bookReading.page') + ' ' + data.page}}</span>
                  </v-chip>
              </div>
              <div class="col-12 pa-0">
                  <p class="d-inline-block font-size-14 mb-0 line-height-130">{{ data.content }}</p>
              </div>
              <div class="col-12 pa-0">
                  <small class="note-date">
                      {{ $t('bookReading.saved_the') }} {{ data.createdDate | formatDate}} hrs.
                  </small>
              </div>
          </div>
          <div class="d-flex col-1 pa-0 align-center justify-end">
              <v-btn
                  icon 
                  small
                  @mouseup.prevent="noteAction" >
                  <v-img :src="trashIcon" width="32"></v-img>
              </v-btn>
          </div>
        </v-row>
      </v-row>

    </v-menu>
  </div>
</template>
<script>
  import { mapActions, mapState } from 'vuex'
  import bookUserNotesService from '@/services/bookUserNotes'
import { no } from 'vuetify/src/locale'

  const indexImg = require('@/assets/img/icons/new-reading/notes-purple.svg')

  export default {
      props: {
          data: { type: Object, default: null },
          note_number: { type: Number, default: null },
          visible: { type: Boolean, default: false },
      },
      computed: {
          noteText(){
              return `${this.$t('bookReading.note_pill_msg')} ${this.$moment(this.data.createdDate).fromNow()}`;
          },
          ...mapState({
            bookReadConf: (state) => state.bookReading.bookReadConf,
            bookUserNotes: (state) => state.bookReading.bookUserNotes,
          }),
      },
      data() {
          return {
              indexImg,
              btnLoaded: false,
              notesDialog: null,
              iconNotes: require('@/assets/img/icons/new-reading/notes-white.svg'),
              trashIcon: require('@/assets/img/icons/new-reading/highlight/icon-trash.svg'),
          }
      },
      methods: {
          ...mapActions('bookReading', [
              'setBookUserNotes',
          ]),
          async noteAction(){
              await bookUserNotesService
                  .deleteNote(this.data.id)
                  .then((response) => {
                      this.setBookUserNotes(response.content)
                  })
                  .catch((error) => console.error(error))
              this.btnLoaded = !this.btnLoaded
          },
          setNotesDialogToFalse(){
              this.notesDialog = false
          },
      },
      filters: {
          // Dar formato a la fecha de creación de la nota
          formatDate(timestamp) {
              const date = new Date(timestamp);
              const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
              const formattedDate = date.toLocaleString('es-ES', options);
              return formattedDate;
          }
      }
  }
</script>
<style lang="scss">
.note-info {
  max-width: 80vh;
}
.main-note-content {
  /* border: 2px solid #4BADA1; */
  background: white;
}
.note-content {
    /* border: 1.5px solid #514773 !important; */
    border-radius: 6px;
    background: #F0F2F4;
    color: #323A46;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)) !important;
    transition: background-image 0.5s ease;
}
.note-date{
    color: #64748B;
}
.btn-closed{
    position: absolute;
    right: 24px;
    left: inherit;
    top: 1em;
    z-index: 10;
  }
</style>
